import { render, staticRenderFns } from "./HomeBenefits.vue?vue&type=template&id=330ed500&scoped=true&"
import script from "./HomeBenefits.vue?vue&type=script&lang=js&"
export * from "./HomeBenefits.vue?vue&type=script&lang=js&"
import style0 from "./HomeBenefits.vue?vue&type=style&index=0&id=330ed500&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330ed500",
  null
  
)

export default component.exports